import React from 'react';
import styled from 'styled-components';
import { Label } from '../..';

const SingleDayWeekWrap = styled.div`
  display: inline-flex;
  width: 100%;
  max-width: 40px;
  text-align: center;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  @media (max-width: 768px) {
    max-width: 14.285714%;
  }
`;
function SingleDayWeek(props: any) {
  const { value } = props;
  return (
    <SingleDayWeekWrap>
      <Label size={14} text={value} color="var(--text-text02)" />
    </SingleDayWeekWrap>
  );
}

export { SingleDayWeek };
